import {
  CSSProperties,
  ElementType,
  ForwardedRef,
  createElement,
  forwardRef,
} from "react";

type AnyProps = Record<string, any>;
type StyleResolver = CSSProperties | ((props: AnyProps) => CSSProperties);

const shouldOmitProp = (key: string, omitProps: string[]) => {
  if (key.startsWith("$")) {
    return true;
  }

  return omitProps.includes(key);
};

const sanitizeProps = (props: AnyProps, omitProps: string[]) =>
  Object.keys(props).reduce<AnyProps>((acc, key) => {
    if (!shouldOmitProp(key, omitProps)) {
      acc[key] = props[key];
    }

    return acc;
  }, {});

export const createStyledElement = (
  element: ElementType,
  style: StyleResolver,
  omitProps: string[] = []
) =>
  forwardRef<any, AnyProps>((props, ref: ForwardedRef<any>) => {
    const { children, style: styleOverride, ...restProps } = props;
    const resolvedStyle = typeof style === "function" ? style(props) : style;
    const sanitizedProps = sanitizeProps(restProps, omitProps);

    return createElement(
      element,
      {
        ...sanitizedProps,
        ref,
        style: { ...resolvedStyle, ...(styleOverride ?? {}) },
      },
      children
    );
  });
